<template>
  <ul v-if="errors && errors.length" class="alert alert--danger mb-3" role="alert">
    <li v-for="(error, errorIndex) in errors" :key="errorIndex">
      {{ error[0] }}
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    errors: {
      type: Array,
      required: true,
      default: () => [],
    }
  }
};
</script>
